import { AppContext } from "@Context/common/general/context";
import React, { useEffect, useState } from "react";

import WizardConfigs from "@Enums/WizardConfigs";

import WelcomeWizardVR from "@Components/wizards/welcome-wizard-vr";
import WizardDialog from "@Components/wizards/wizard-dialog";

import Event from "@Helpers/event";

interface IShowWizardDialog {
  slidesConfigName: string;
  contexts: string[];
  exitEvent: Event;
}

export default () => {
  const { state, dispatch } = React.useContext(AppContext);
  const [wizardOpen, setWizardOpen] = useState(false);
  const [exitDialogEvent, setExitDialogEvent] = useState<Event>();
  const [visableContexts, setVisibleContexts] = useState<string[] | null>(null);
  const [slidesConfig, setSlidesConfig] = useState<any>(null);
  const [allAccessUser] = useState(state.user.hasAllAccessSubscription);

  const showWizardDialog = ({ slidesConfigName, contexts = [], exitEvent = new Event() }: IShowWizardDialog) => {
    // Add all access context to dialog if user has the subscription
    if (allAccessUser) {
      contexts.push("all_access_user");
    } else {
      contexts.push("bootcamp_user");
    }

    let slidesConfig = null;
    switch (slidesConfigName) {
      case WizardConfigs.WELCOME_WIZARD_VR:
        slidesConfig = WelcomeWizardVR;
        break;
      default:
        return;
    }

    if (!slidesConfig) return console.error("No slides config matching for name: " + slidesConfigName);

    setExitDialogEvent(exitEvent);
    setVisibleContexts(contexts);
    setSlidesConfig(slidesConfig);
    toggleWizard(true);
    exitEvent.on(() => {
      setExitDialogEvent(undefined);
      setVisibleContexts(null);
      setSlidesConfig(null);
      toggleWizard(false);
    });
  };

  const hideWizardDialog = () => {
    toggleWizard(false);
  };

  useEffect(() => {
    state.app.events.showWizardDialog.on(showWizardDialog);
    state.app.events.hideWizardDialog.on(hideWizardDialog);
    return () => {
      state.app.events.showWizardDialog.remove(showWizardDialog);
      state.app.events.hideWizardDialog.remove(hideWizardDialog);
    };
  }, []);

  const toggleWizard = (open: boolean) => {
    setWizardOpen(open !== undefined ? open : !wizardOpen);
  };

  return (
    <div id={"WIZARD_SERVICE"}>
      {wizardOpen ? <WizardDialog open={wizardOpen} slidesConfig={slidesConfig} contexts={visableContexts} exitEvent={exitDialogEvent} /> : null}
    </div>
  );
};
